module.exports = __webpack_public_path__ + "files/a7ffaaf00407d8467976e46d22aa85bf.svg";